import {
  FUMBLE_INPUTS,
  NON_KICKOFF_TOUCHBACK_YARDLINE,
  PENALTY_INPUTS,
  PUNT_RESULT_INPUTS,
  REF_EVENT_INPUTS,
  REGULAR_PLAY_INPUTS,
  TEventTypes,
  TPlayDesigns,
  TPlayResultTypes,
  YARDAGE_SELECTOR_BUTTONS,
} from '@/constants';
import {
  IConfirmationInput,
  IMachineContext,
  ITwoRowGenericSelectorInp,
  IYardageSelectorInput,
  TMetaFuncInput,
  TPlayResults,
  TPlays,
  TPuntEvents,
  TRefEventsActions,
  TRegularPlayEvents,
  TWorkflowType,
} from '@/types';
import { refEventValue } from '@/utilities';

export const onPuntTypeSelected = ({
  send,
  payload,
  generalState,
  playFlowState,
  context,
}: TMetaFuncInput) => {
  switch (payload.value) {
    case TPlays.PUNT:
      send(TPuntEvents.PUNT_SELECTED, {
        nextStateInput: PUNT_RESULT_INPUTS,
        ctxUpdate: {
          currentPlay: {
            ...context.currentPlay,
            playDesignId: TPlayDesigns.PUNT,
            options: {
              isKickoffOrPunt: true,
            },
          },
        },
      });
      break;
    case TPlays.FAKE_PUNT:
      send(TPuntEvents.FAKE_SELECTED, {
        ctxUpdate: {
          currentWorkflow: TWorkflowType.REGULAR_PLAY,
          currentPlay: {
            ...context.currentPlay,
            options: {
              ...context.currentPlay?.options,
              isKickoffOrPunt: false,
              isFakePunt: true,
            },
          },
        },
        nextStateInput: REGULAR_PLAY_INPUTS(TRegularPlayEvents.BACK_TO_FAKE_PUNT),
      });
      break;
    case TPlays.FUMBLE:
      send(TPuntEvents.ON_FUMBLE, {
        nextStateInput: FUMBLE_INPUTS(TPuntEvents.TO_START),
      });
      break;
    case TPlays.REF:
      playFlowState.pushEvent(
        {
          eventTypeId: TEventTypes.REF_EVENT,
          value: refEventValue(playFlowState.driveNumber, playFlowState.drivePlayNumber),
        },
        generalState.currentGame.gameId
      );

      send(TPuntEvents.ON_REF, {
        nextStateInput: {
          ...REF_EVENT_INPUTS,
          backTo: TRefEventsActions.BACK_FROM_REF,
        } as ITwoRowGenericSelectorInp,
      });
      break;
    default:
  }
};

export const onPuntResultSelected = ({
  send,
  payload,
  generalState,
  playFlowState,
  context,
}: TMetaFuncInput) => {
  if (
    payload.toggles[TPlays.PENALTY_ALERT] &&
    payload.value !== TPlayResults.PUNT_RETURN &&
    payload.value !== TPlayResults.FAIR_CATCH_OR_DOWNED
  ) {
    playFlowState.pushEvent(
      {
        eventTypeId: TEventTypes.REF_EVENT,
        value: refEventValue(playFlowState.driveNumber, playFlowState.drivePlayNumber),
      },
      generalState.currentGame.gameId
    );

    return send(TPuntEvents.PENALTY_SELECTED, {
      ctxUpdate: {
        currentPlay: {
          ...context.currentPlay,
          options: {
            ...context.currentPlay?.options,
            isPenaltyDuringReturn: true,
          },
        },
      } as IMachineContext,
      nextStateInput: {
        ...PENALTY_INPUTS(
          playFlowState.currentTeamRoles.offense,
          generalState.teams[playFlowState.currentTeamRoles.offense].logoUrl,
          playFlowState.currentTeamRoles.defense,
          generalState.teams[playFlowState.currentTeamRoles.defense].logoUrl
        ),
        backTo: TRefEventsActions.BACK_TO_PUNT_RESULT,
      } as ITwoRowGenericSelectorInp,
    });
  }

  switch (payload.value) {
    case TPlayResults.TOUCHBACK:
      send(TPuntEvents.TO_CONFIRMATION, {
        ctxUpdate: {
          currentPlay: {
            playDesignId: TPlayDesigns.PUNT,
            resultType: [TPlayResultTypes.TOUCHBACK],
            postPlayYardLine: NON_KICKOFF_TOUCHBACK_YARDLINE,
            postPlaySide: playFlowState.presentStateBasedOnCurrentMode.driveDirection,
          },
        } as IMachineContext,
        nextStateInput: {
          backTo: TPuntEvents.BACK_TO_PUNT_RESULT,
        } as IConfirmationInput,
      });
      break;
    case TPlayResults.FAIR_CATCH_OR_DOWNED:
    case TPlayResults.PUNT_RETURN:
      send(TPuntEvents.TO_YARDAGE, {
        nextStateInput: {
          buttons: YARDAGE_SELECTOR_BUTTONS(payload.toggles[TPlays.PENALTY_ALERT]),
          sliderLabels: {
            left: generalState.teams[playFlowState.teams.left].abbreviation,
            right: generalState.teams[playFlowState.teams.right].abbreviation,
          },
        } as IYardageSelectorInput,
        ctxUpdate: {
          currentPlay: {
            playDesignId: TPlayDesigns.PUNT,
            resultType: [TPlayResultTypes.FIRST_DOWN],
            postPlayYardLine: NON_KICKOFF_TOUCHBACK_YARDLINE,
            postPlaySide: playFlowState.presentStateBasedOnCurrentMode.driveDirection,
          },
        } as IMachineContext,
      });
      break;
    case TPlays.FUMBLE:
      send(TPuntEvents.ON_FUMBLE, {
        nextStateInput: FUMBLE_INPUTS(TPuntEvents.BACK_TO_PUNT_RESULT),
      });
      break;
    default:
  }
  return null;
};
